import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './shared/Footer/Footer';
import ScrollToTop from './ScrollToUp';
import { CartContextProvider } from './context/CartContext';
import Loading from './components/Loading/Loading';
import WhatsappButton from './components/WhatsappButton';

const Home = lazy(() => import('./components/Home/Home'));
const Products = lazy(() => import('./components/Products/Products'));
const ProductId = lazy(() => import('./components/Products/ProductId/ProductId'));
const Contact = lazy(() => import('./components/Contact/Contact'));
const Cart = lazy(() => import('./components/cart/Cart'));
const Success = lazy(() => import('./components/Checkout/Success'));
const Failure = lazy(() => import('./components/Checkout/Failure'));
const Pending = lazy(() => import('./components/Checkout/Pending'));

function App() {

  return (
    <CartContextProvider>
      <BrowserRouter>
        <Header />
        <WhatsappButton />
        <ScrollToTop />
        <main id="main-content">
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products3d" element={<Products />} />
              <Route path="/productsLaser" element={<Products />} />
              <Route path="/productsMates" element={<Products />} />
              <Route path="/productsBbq" element={<Products />} />
              <Route path="/productsLaser/:productId" element={<ProductId />} />
              <Route path="/products3D/:productId" element={<ProductId />} />
              <Route path="/productsMates/:productId" element={<ProductId />} />
              <Route path="/productsBbq/:productId" element={<ProductId />} />
              <Route path="/cart" element={<Cart />} />
              <Route path='/event/:eventId' element={<Products />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/success" element={<Success />} />
              <Route path="/failure" element={<Failure />} />
              <Route path="/pending" element={<Pending />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </BrowserRouter>
    </CartContextProvider >
  );
}

export default App;